// extracted by mini-css-extract-plugin
export default {"chip":"styles_chip__dbnP9","ellipseChip":"styles_ellipseChip__2+I4N","smallChip":"styles_smallChip__L4N4m","label":"styles_label__iYTcJ","smallLabel":"styles_smallLabel__6KRxG"};